import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useAppSelector } from '@/redux/hooks'

// Libs

// Components
import Link from '@/components/common/Link'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  const memberData = useAppSelector((state) => state?.member?.memberData)

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link url={EXTERNAL_LINK.PACIFIC_PINE_SPORTS_OFFICIAL_SITE} isOpen>
          <div className={cx('header-logo')}>
            <Image src={`/images/pps-logo.png`} width={200} height={50} alt={'Winner Pickle Ball'} />
          </div>
        </Link>
        {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
      </div>
    </header>
  )
}

export default SimpleHeader
